// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"489a20aa","348":"bd379749","436":"caa7d364"}[chunkId] + ".chunk.css";
};